import React from 'react';

import { connect } from 'react-redux';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from '../../components/CustomInput/CustomInput';
import ReactSelect from '../../components/Select/ReactSelect';
import CustomButton from "components/CustomButtons/Button.jsx";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProductsIcon, CustomersIcon, ServicesIcon } from '../../variables/dataIcons';
import { withStyles, FormControlLabel, Switch } from '@material-ui/core';
import { faDollarSign } from '@fortawesome/pro-solid-svg-icons';
import Api from '../../api/Api.js';
import CustomerEndpoints from '../../api/CustomerEndpoints';
import ServiceEndpoints from '../../api/ServiceEndpoints';
import { SET_SERVICE_LIST, SET_CUSTOMER_LIST } from '../../redux/types';
import { store } from '../../redux/store';
import AccountImage from '../../components/Image/AccountImage';
import { Check } from '@material-ui/icons';
import NumberMaskInput from '../../components/CustomInput/NumberMaskInput';
import ProductEndpoints from '../../api/ProductEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    },
    label: {
        color: '#333',
        fontSize: 15
    }
};

class AddProducts extends React.Component {

    state = {
        name: '',
        nameState: '',
        description: '',
        accounts: [],
        services: [],
        pricings: []
    };

    componentDidMount() {
        Api.get(CustomerEndpoints.list).then(({ data }) => store.dispatch({ type: SET_CUSTOMER_LIST, payload: data })).catch((e) => console.error(e));
        Api.get(ServiceEndpoints.list).then(({ data }) => store.dispatch({ type: SET_SERVICE_LIST, payload: data })).catch((e) => console.error(e));
    }

    submit() {
        Api.post(ProductEndpoints.add, { ...this.state, accounts: this.state.accounts.map(x => x.value), pricings: this.state.pricings.map((x, i) => ({ ...x, service_id: this.state.services[i].value })) })
        .then(({ data }) => {
            console.log(data);
        })
        .catch((e) => {
            console.error(e);
        })
    }

    render() {

        const { classes } = this.props;

        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={2}></GridItem>
                <GridItem xs={12} sm={8}>
                    <Card className={classes.container}>
                        <CardBody className={classes.content}>
                            <h3 className={classes.infoText}>
                                <FontAwesomeIcon style={{ marginRight: 8 }} icon={ProductsIcon} />
                                Add Product
                            </h3>

                            <CustomInput
                                success={this.state.nameState === "success"}
                                error={this.state.nameState === "error"}
                                labelText={
                                    <span>
                                        Product Name <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ name: event.target.value, nameState: event.target.value ? "success" : "error" }),
                                    value: this.state.name,
                                }}
                            />

                            <CustomInput
                                labelText={<span>Product Description</span>}
                                id="description"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ description: event.target.value }),
                                    value: this.state.description,
                                }}
                            />

                            <CustomButton
                                onClick={() => this.submit()}
                                style={{ float: 'right' }}
                                round
                                color="rose"
                            >
                                Add New Product <Check />
                            </CustomButton>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={2}></GridItem>
                <GridItem xs={12} sm={2}></GridItem>
                <GridItem xs={12} sm={4}>
                    <Card className={classes.container}>
                        <CardBody className={classes.content}>
                            <h3 className={classes.infoText}>
                                <FontAwesomeIcon style={{ marginRight: 8 }} icon={CustomersIcon} />
                                Accounts
                            </h3>
                            <h5 className={classes.infoText}>
                                Accounts using Product <small>(optional)</small>
                            </h5>

                            <ReactSelect
                                label="Select Accounts"
                                options={
                                    this.props.accounts && this.props.accounts.length > 0 ?
                                        this.props.accounts.map(acc => ({ label: acc.account_no + " - " + acc.name, avatar: <AccountImage {...acc} />, value: acc.id }))
                                        :
                                        [{ label: 'Loading...', value: '' }]
                                }
                                onChange={(value) => this.setState({ accounts: value })}
                                placeholder="Select Accounts..."
                                value={this.state.accounts}
                                isClearable
                                isSearchable
                                isMulti
                                isLoading={!this.props.accounts || this.props.accounts.length === 0}
                                isDisabled={!this.props.accounts || this.props.accounts.length === 0}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={4}>
                    <Card className={classes.container}>
                        <CardBody className={classes.content}>
                            <h3 className={classes.infoText}>
                                <FontAwesomeIcon style={{ marginRight: 8 }} icon={ServicesIcon} />
                                Services
                            </h3>
                            <h5 className={classes.infoText}>
                                Services provided by Product <small>(required)</small>
                            </h5>

                            <ReactSelect
                                label="Select Services"
                                options={
                                    this.props.services && this.props.services.length > 0 ?
                                        this.props.services.map(serv => ({ label: serv.name, value: serv.id }))
                                        :
                                        [{ label: 'Loading...', value: '' }]
                                }
                                onChange={(value) => {

                                    var newPricings = this.state.pricings;

                                    if (value.length > newPricings.length) {
                                        newPricings.push({ sub: false, trans: true, subPrice: 0, subPriceFormatted: 'R0.00', subPriceState: '', transPrice: 0, transPriceFormatted: 'R0.00', transPriceState: '' });
                                    } else if (value.length < newPricings.length) {
                                        newPricings.pop();
                                    }

                                    this.setState({ services: value, pricings: newPricings });
                                }}
                                placeholder="Select Services..."
                                value={this.state.services}
                                isClearable
                                isSearchable
                                isMulti
                                isLoading={!this.props.services || this.props.services.length === 0}
                                isDisabled={!this.props.services || this.props.services.length === 0}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={2}></GridItem>
                <GridItem xs={12} sm={2}></GridItem>
                <GridItem xs={12} sm={8}>
                    {
                        this.state.services.length > 0 ?
                            this.state.services.map((serv, i) => {

                                var { pricings } = this.state;
                                var currentPrice = pricings[i];

                                return (
                                    <Card key={i} className={classes.container}>
                                        <CardBody className={classes.content}>
                                            <h5 className={classes.infoText}>
                                                <FontAwesomeIcon style={{ marginRight: 8 }} icon={faDollarSign} />
                                                Default Price For: <strong>{serv.label}</strong>
                                            </h5>

                                            <GridContainer>
                                                <GridItem xs={12} sm={6}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={currentPrice.sub}
                                                                onChange={() => {
                                                                    this.state.pricings[i].sub = !currentPrice.sub;
                                                                    this.setState({ pricings: this.state.pricings });
                                                                }}
                                                                classes={{
                                                                    switchBase: classes.switchBase,
                                                                    checked: classes.switchChecked,
                                                                    icon: classes.switchIcon,
                                                                    iconChecked: classes.switchIconChecked,
                                                                    bar: classes.switchBar
                                                                }}
                                                            />
                                                        }
                                                        classes={{
                                                            label: classes.label
                                                        }}
                                                        label="Subscription Charge"
                                                    />
                                                    <NumberMaskInput
                                                        success={currentPrice.subPriceState === "success"}
                                                        error={currentPrice.subState === "error"}
                                                        labelText={
                                                            <span>
                                                                Price {!this.state.pricings[i].sub ? <small>(disabled)</small> : <small>(required)</small>}
                                                            </span>
                                                        }
                                                        id="price"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => {
                                                                this.state.pricings[i].subPrice = event.target.floatValue;
                                                                this.state.pricings[i].subPriceFormatted = event.target.formattedValue;
                                                                this.state.pricings[i].subPriceState = (event.target.formattedValue ? "success" : "error");
                                                                this.setState({ pricings: this.state.pricings })
                                                            },
                                                            value: currentPrice.priceFormatted,
                                                            disabled: !this.state.pricings[i].sub
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={6}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={this.state.pricings[i].trans}
                                                                onChange={() => {
                                                                    this.state.pricings[i].trans = !currentPrice.trans;
                                                                    this.setState({ pricings: this.state.pricings })
                                                                }}
                                                                classes={{
                                                                    switchBase: classes.switchBase,
                                                                    checked: classes.switchChecked,
                                                                    icon: classes.switchIcon,
                                                                    iconChecked: classes.switchIconChecked,
                                                                    bar: classes.switchBar
                                                                }}
                                                            />
                                                        }
                                                        classes={{
                                                            label: classes.label
                                                        }}
                                                        label="Transaction Charge"
                                                    />
                                                    <NumberMaskInput
                                                        success={currentPrice.transState === "success"}
                                                        error={currentPrice.transState === "error"}
                                                        labelText={
                                                            <span>
                                                                Price {!this.state.pricings[i].trans ? <small>(disabled)</small> : <small>(required)</small>}
                                                            </span>
                                                        }
                                                        id="price"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => {
                                                                this.state.pricings[i].transPrice = event.target.floatValue;
                                                                this.state.pricings[i].transPriceFormatted = event.target.formattedValue;
                                                                this.state.pricings[i].transPriceState = (event.target.formattedValue ? "success" : "error");
                                                                this.setState({ pricings: this.state.pricings })
                                                            },
                                                            value: currentPrice.priceFormatted,
                                                            disabled: !this.state.pricings[i].trans
                                                        }}
                                                    />
                                                </GridItem>
                                                {/* 
                                                    <GridItem xs={12} sm={6}>

                                                    </GridItem>
                                                    <GridItem xs={12} sm={6}>

                                                    </GridItem>
                                                */}
                                            </GridContainer>

                                        </CardBody>
                                    </Card>
                                )
                            })
                            :
                            null
                    }
                </GridItem>
                <GridItem xs={12} sm={2}></GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        services: state.services.list,
        accounts: state.customers.list
    }
}

export default withStyles({ ...regularFormsStyle, ...extendedFormsStyle, ...style })(connect(mapStateToProps)(AddProducts));
